import React from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./components/style.css";

import {
  ConsultaBilhetes,
  RelatorioBilhetes,
  RelatorioMovimento,
} from "./pages";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RelatorioMovimento />} />
        <Route path="/home" element={<RelatorioMovimento />} />
        <Route path="/consultaBilhetes" element={<ConsultaBilhetes />} />
        <Route path="/relatorioBilhetes" element={<RelatorioBilhetes />} />
        <Route path="/relatorioMovimento" element={<RelatorioMovimento />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
